import React from 'react';
import { useDebug } from '../../contexts/DebugContext';

const DebugToggle = ({ 
  style = {}, 
  position = 'bottom-left',
  showShortcut = true,
  iconOnly = false 
}) => {
  const { isDebugVisible, isDebugAllowed, toggleDebugMode, isDevelopment } = useDebug();

  // Don't render if debug is not allowed or in production
  if (!isDebugAllowed || !isDevelopment) {
    return null;
  }

  const getPositionStyles = () => {
    const baseStyle = {
      position: 'fixed',
      zIndex: 9998,
      ...style
    };

    switch (position) {
      case 'top-left':
        return { ...baseStyle, top: '10px', left: '10px' };
      case 'top-right':
        return { ...baseStyle, top: '10px', right: '10px' };
      case 'bottom-left':
        return { ...baseStyle, bottom: '10px', left: '10px' };
      case 'bottom-right':
        return { ...baseStyle, bottom: '10px', right: '10px' };
      default:
        return { ...baseStyle, bottom: '10px', left: '10px' };
    }
  };

  return (
    <div style={getPositionStyles()}>
      <button
        onClick={toggleDebugMode}
        style={{
          backgroundColor: isDebugVisible ? '#00ff00' : 'rgba(0, 0, 0, 0.7)',
          color: isDebugVisible ? '#000' : '#fff',
          border: '1px solid rgba(255, 255, 255, 0.3)',
          borderRadius: '6px',
          padding: iconOnly ? '6px' : '6px 12px',
          fontSize: '11px',
          fontFamily: 'monospace',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          gap: '6px',
          transition: 'all 0.2s ease',
          boxShadow: '0 2px 8px rgba(0, 0, 0, 0.2)',
        }}
        title={`${isDebugVisible ? 'Hide' : 'Show'} debug menu${showShortcut ? ` (${navigator.platform.toUpperCase().indexOf('MAC') >= 0 ? 'Cmd' : 'Ctrl'}+Shift+D)` : ''}`}
      >
        <span style={{ fontSize: '12px' }}>🐛</span>
        {!iconOnly && (
          <span>
            {isDebugVisible ? 'Debug ON' : 'Debug OFF'}
          </span>
        )}
      </button>
    </div>
  );
};

export default DebugToggle;
